<script>
import { mapGetters } from 'vuex';
import { useAlert, useTrack } from 'dashboard/composables';
import CsatMetrics from './components/CsatMetrics.vue';
import CsatTable from './components/CsatTable.vue';
import CsatFilters from './components/Csat/CsatFilters.vue';
import { generateFileName } from '../../../../helper/downloadHelper';
import { REPORTS_EVENTS } from '../../../../helper/AnalyticsHelper/events';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import V4Button from 'dashboard/components-next/button/Button.vue';
import ReportHeader from './components/ReportHeader.vue';
import DownloadPdfButton from 'dashboard/components/reports/DownloadPdfButton.vue';
import ReportNarrativeSummary from './components/ReportNarrativeSummary.vue';
import CsatByAgentCard from 'dashboard/components-next/reports/csat/CsatByAgentCard.vue';

export default {
  name: 'CsatResponses',
  components: {
    CsatByAgentCard,
    CsatMetrics,
    CsatTable,
    CsatFilters,
    ReportHeader,
    V4Button,
    DownloadPdfButton,
    ReportNarrativeSummary,
  },
  data() {
    return {
      pageIndex: 0,
      from: 0,
      to: 0,
      userIds: [],
      inbox: null,
      team: null,
      rating: null,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      isFeatureEnabledOnAccount: 'accounts/isFeatureEnabledonAccount',
      csatMetrics: 'csat/getMetrics',
    }),
    csatSignals() {
      return this.csatMetrics.signals || [];
    },
    // so periodo e caixa: o CSAT por agente nao recorta por agente nem por nota
    csatAgentFilters() {
      return { from: this.from, to: this.to, inboxId: this.inbox };
    },
    requestPayload() {
      return {
        from: this.from,
        to: this.to,
        user_ids: this.userIds,
        inbox_id: this.inbox,
        team_id: this.team,
        rating: this.rating,
      };
    },
    isTeamsEnabled() {
      return this.isFeatureEnabledOnAccount(
        this.accountId,
        FEATURE_FLAGS.TEAM_MANAGEMENT
      );
    },
  },
  mounted() {
    this.$store.dispatch('agents/get');
  },
  methods: {
    getAllData() {
      try {
        this.$store.dispatch('csat/getMetrics', this.requestPayload);
        this.getResponses();
      } catch {
        useAlert(this.$t('REPORT.DATA_FETCHING_FAILED'));
      }
    },
    getResponses() {
      this.$store.dispatch('csat/get', {
        page: this.pageIndex + 1,
        ...this.requestPayload,
      });
    },
    downloadReports() {
      const type = 'csat';
      try {
        this.$store.dispatch('csat/downloadCSATReports', {
          fileName: generateFileName({ type, to: this.to }),
          ...this.requestPayload,
        });
      } catch (error) {
        useAlert(this.$t('CSAT_REPORTS.DOWNLOAD_FAILED'));
      }
    },
    onPageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.getResponses();
    },
    onFilterChange({
      from,
      to,
      selectedAgents,
      selectedInbox,
      selectedTeam,
      selectedRating,
    }) {
      // do not track filter change on initial load
      if (this.from !== 0 && this.to !== 0) {
        useTrack(REPORTS_EVENTS.FILTER_REPORT, {
          filterType: 'date',
          reportType: 'csat',
        });
      }

      this.from = from;
      this.to = to;
      this.userIds = selectedAgents.map(el => el.id);
      this.inbox = selectedInbox?.id;
      this.team = selectedTeam?.id;
      this.rating = selectedRating?.value;

      this.getAllData();
    },
  },
};
</script>

<template>
  <ReportHeader :header-title="$t('CSAT_REPORTS.HEADER')">
    <div class="flex items-center gap-2">
      <DownloadPdfButton report-type="csat" :filters="requestPayload" />
      <V4Button
        :label="$t('CSAT_REPORTS.DOWNLOAD')"
        icon="i-lucide-download"
        size="sm"
        @click="downloadReports"
      />
    </div>
    <template #filters>
      <CsatFilters
        :show-team-filter="isTeamsEnabled"
        @filter-change="onFilterChange"
      />
    </template>
  </ReportHeader>

  <div class="flex flex-col gap-4">
    <ReportNarrativeSummary :signals="csatSignals" />
    <CsatMetrics :filters="requestPayload" />
    <CsatByAgentCard :filters="csatAgentFilters" />
    <CsatTable :page-index="pageIndex" @page-change="onPageNumberChange" />
  </div>
</template>
